var _circle, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserCompany(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 22,
    fill: "#FDAB29"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.9997 35.1921C28.8038 35.1921 34.3197 32.4341 34.3197 29.0321C34.3197 25.63 28.8038 22.8721 21.9997 22.8721C15.1955 22.8721 9.67969 25.63 9.67969 29.0321C9.67969 32.4341 15.1955 35.1921 21.9997 35.1921Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0001 34.7535C28.5613 34.7535 33.8801 32.1925 33.8801 29.0335C33.8801 25.8744 28.5613 23.3135 22.0001 23.3135C15.439 23.3135 10.1201 25.8744 10.1201 29.0335C10.1201 32.1925 15.439 34.7535 22.0001 34.7535Z",
    fill: "white",
    stroke: "#FDAB29"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0002 26.393C26.8603 26.393 30.8002 22.4531 30.8002 17.593C30.8002 12.7329 26.8603 8.79297 22.0002 8.79297C17.1401 8.79297 13.2002 12.7329 13.2002 17.593C13.2002 22.4531 17.1401 26.393 22.0002 26.393Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0006 25.9544C26.6177 25.9544 30.3606 22.2115 30.3606 17.5944C30.3606 12.9773 26.6177 9.23438 22.0006 9.23438C17.3835 9.23438 13.6406 12.9773 13.6406 17.5944C13.6406 22.2115 17.3835 25.9544 22.0006 25.9544Z",
    fill: "white",
    stroke: "#FDAB29"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCompany);
export default __webpack_public_path__ + "static/media/user_company.6e943f58b1342dca6142a7ab74462e33.svg";
export { ForwardRef as ReactComponent };